import { Outlet, Navigate } from "react-router-dom";
import { PATHS } from "./Routes";
import AuthenticationService from "../Service/AuthenticationService";

const PrivateRoute = () => {
  const isAuthenticated = AuthenticationService.isAuthenticated;
  const role = AuthenticationService.role;
  return isAuthenticated && role === "Default" ? (
    <Outlet />
  ) : (
    <Navigate to={PATHS.Home} />
  );
};

export default PrivateRoute;
